import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import withConfig from '../../wrappers/withConfig'
import 'jspdf-autotable'
import Spinner from '../../elem/Spinner'
import BackButton from '../../elem/BackButton'
import PageNotFound from '../../PageNotFound'
import { Helmet } from 'react-helmet-async'
import JobOverview from './JobOverview'
import DisclosureOverview from './DisclosureOverview'
import IngredientTable from './IngredientTable'

const DisclosureDetailComponent = ({ config }) => {
    const { id } = useParams()
    const [data, setData] = useState(null)
    const [overviewData, setOverviewData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState(null)
    const [hasError, setHasError] = useState(false)
    const { API_URL } = config
    const [isNonOG, setIsNonOG] = useState(false);


    useEffect(() => {
        if (!id) return

        const fetchWellData = async () => {
            setLoading(true)
            setHasError(false)
            setErrorMessage(null)

            try {
                let disclosureApiUrl = ''

                // API number
                if (id.length <= 14) {
                    const metaRes = await axios.get(`${API_URL}/FracFocus/WellTypeByApiNumber?api14=${id}`)
                    const wellType = metaRes.data?.wellType
                    const nonOG = wellType !== 'Oil' && wellType !== 'Gas'
                    setIsNonOG(nonOG)

                    // Choose API based on wellType
                    disclosureApiUrl = nonOG
                        ? `${API_URL}/FracFocus/NonOGWellByApiNumber?api14=${id}`
                        : `${API_URL}/FracFocus/WellByApiNumber?api14=${id}`
                } 
                // PKey
                else {
                    disclosureApiUrl = `${API_URL}/FracFocus/NonOGWellByPKey?pKey=${id}`
                    setIsNonOG(true)
                }

                const disclosureRes = await axios.get(disclosureApiUrl)
                const Wells = disclosureRes.data?.Wells

                if (Wells && Wells.length > 0) {
                    setData(Wells)
                    setOverviewData(Wells[0])
                } else {
                    throw new Error('No matching well data')
                }
            } catch (error) {
                console.error('Fetch error:', error)
                setOverviewData(null)
                setData(null)
                setHasError(true)
                setErrorMessage(error.message || 'Failed to fetch the data.')
            } finally {
                setLoading(false)
            }
        }

        fetchWellData()
    }, [API_URL, id])


    return (
        <div className="container_page">
            <Helmet>
                <title>Disclosure</title>
                <link rel="icon" href="/favicon.ico" />
            </Helmet>
            <div>
                <BackButton
                    label={`< BACK TO SEARCH`}
                    extraClass={'back_to_search'}
                />
            </div>
            {/* Conditionally Rendering *********************** */}
            {overviewData && (
                <div className="page">
                    <DisclosureOverview
                        overviewData={overviewData}
                        loading={loading}
                        isNonOG={isNonOG}
                    />
                    {data.map((wellData) => (
                        <div key={wellData.pKey}>
                            <JobOverview data={wellData} isNonOG={isNonOG} />
                            <IngredientTable data={wellData} />
                        </div>
                    ))}

                    <div id="fineprint">
                        <p className="closing">
                            Total Water Volume sources may include various types
                            of water including fresh water, produced water, and
                            recycled water. Information is based on the maximum
                            potential for concentration and thus the total may
                            be over 100%.
                        </p>
                        <div></div>
                    </div>
                    {errorMessage ? (
                        <div className="errorMessage">{errorMessage}</div>
                    ) : null}
                </div>
            )}
            {!data && !hasError && <Spinner />}
            {hasError && <PageNotFound />}
        </div>
    )
}

const DisclosureDetail = withConfig(DisclosureDetailComponent)

export default DisclosureDetail
